import { render, staticRenderFns } from "./CreateDataObject.vue?vue&type=template&id=51c73a48&"
import script from "./CreateDataObject.vue?vue&type=script&lang=js&"
export * from "./CreateDataObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports